// Sohbet yan paneli (dock) durumu — kullanıcı tercihi olarak KALICI saklanır.
// Amaç: teklif/izin gibi bir ekrandan çıkmadan mesaj okuyup yazabilmek; sayfa
// değişince panel açık kalır (design_handoff_sohbet_panel).
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const DOCK_W_MIN = 300
export const DOCK_W_MAX = 720
export const DOCK_W_NARROW = 360
export const DOCK_W_WIDE = 520
export const DOCK_W_DEFAULT = 400

function clampDockW(w) {
  const n = Number(w)
  if (!Number.isFinite(n)) return DOCK_W_DEFAULT
  return Math.min(DOCK_W_MAX, Math.max(DOCK_W_MIN, Math.round(n)))
}

export const useChatDock = create(
  persist(
    (set, get) => ({
      open: false,        // yan panel açık mı
      listOpen: true,     // panel içi kanal listesi açık mı
      dockWidth: DOCK_W_DEFAULT,  // sürükle-bırak / akordeon genişliği (px)
      activeId: null,     // seçili kanal / DM
      // Bildirimden gelen odak — KALICI DEĞİL (partialize dışında): eski bir bildirimin
      // mesajı sayfa yenilenince tekrar vurgulanmasın.
      focusMessageId: null,   // akışta vurgulanacak/kaydırılacak mesaj (?m=)
      focusThreadId: null,    // açılacak konu (yanıt bildirimi)

      toggle: () => set((s) => ({ open: !s.open })),
      close: () => set({ open: false }),
      toggleList: () => set((s) => ({ listOpen: !s.listOpen })),
      setDockWidth: (w) => set({ dockWidth: clampDockW(w) }),
      // Dar ↔ geniş snap (eski wide toggle)
      toggleWide: () => set((s) => ({
        dockWidth: s.dockWidth >= (DOCK_W_NARROW + DOCK_W_WIDE) / 2 ? DOCK_W_NARROW : DOCK_W_WIDE,
      })),
      // Kullanıcı elle kanal seçince bildirim odağı düşer — eski mesaj vurgulu kalmasın
      setActive: (id) => set({ activeId: id, focusMessageId: null, focusThreadId: null }),

      // Bildirimden açılış: paneli aç + ilgili kanalı seç (tam ekrana GİTMEZ —
      // kullanıcı bulunduğu sayfada kalsın, isterse sonra tam ekrana geçer).
      openChannel: (id, opts = {}) => set({
        open: true,
        activeId: id ?? get().activeId,
        focusMessageId: opts.messageId ?? null,
        focusThreadId: opts.threadId ?? null,
      }),
      clearFocus: () => set({ focusMessageId: null, focusThreadId: null }),
    }),
    {
      name: 'vertex-chat-dock',
      version: 2,
      migrate: (persisted, version) => {
        const s = persisted || {}
        if (version < 2) {
          // Eski wide boolean → dockWidth
          const dockWidth = s.wide ? DOCK_W_WIDE : (s.dockWidth ? clampDockW(s.dockWidth) : DOCK_W_DEFAULT)
          const { wide: _w, ...rest } = s
          return { ...rest, dockWidth }
        }
        return { ...s, dockWidth: clampDockW(s.dockWidth) }
      },
      partialize: (s) => ({
        open: s.open,
        listOpen: s.listOpen,
        dockWidth: s.dockWidth,
        activeId: s.activeId,
      }),
    },
  ),
)
